import styled from "styled-components";

const Popover = styled.div`
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding};
  background: white;
  border: 0.063em solid ${props => props.theme.colors.border};
  box-shadow: 0 0.125em 0.063em 0 rgba(0, 0, 0, 0.02);
  border-radius: 0.313em;
  z-index: 2;
  position: relative;
`;

Popover.defaultProps = {
  maxWidth: "44.750em",
  padding: "1.375em 1.688em",
  onClick: event => event.stopPropagation(),
};

export default Popover;
